import { MESSAGE_BOX_VARIANT_WARNING, MessageBox } from 'mailup-web-components'

import { useIntl } from 'react-intl'

const HeaderMessageBox = () => {
  const intl = useIntl()

  return (
    <span>
      <MessageBox variant={MESSAGE_BOX_VARIANT_WARNING}>
        {intl.formatMessage(
          { id: 'Load.SelectEmailMessage.Info' },
          {
            linebreak: <br />,
            strong: (str) => <strong>{str}</strong>
          }
        )}
      </MessageBox>
    </span>
  )
}

export default HeaderMessageBox
